import React from 'react';
import { Field } from 'formik';
import { DatePicker as AntDatePicker } from 'antd';
import moment from 'moment';
import styled from 'styled-components';
import { FormikErrors, FormikTouched } from 'formik';

// Custom DatePicker component that works with Formik
export const DatePicker = React.forwardRef<any, any>((props, ref) => {
  const { field, form, ...rest } = props;
  
  return (
    <AntDatePicker
      ref={ref}
      value={field?.value ? moment(field.value) : null}
      onChange={(date) => form.setFieldValue(field.name, date?.toDate())}
      onBlur={() => form.setFieldTouched(field.name, true)}
      getPopupContainer={(trigger) => trigger.parentElement || document.body}
      {...rest}
    />
  );
});

DatePicker.displayName = 'DatePicker';